module.exports = __webpack_public_path__ + "static/media/cyberx_logo.f47e06fc.png";